// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"9d865f6c","150":"fa946131","159":"43a22d35","422":"b6e922a7"}[chunkId] + ".chunk.js";
};